import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const upsertInventoryItem = unaryRpc({
  name: "upsertInventoryItem" as const,
  input: z.object({
    variantId: z.string(),
    warehouseId: z.string(),
    quantity: z.number().min(1, "Quantity must be greater than 0"),
    price: z.number().min(0.01, "Price must be greater than 0"),
  }),
  output: z.object({
    inventoryItem: z.object({
      _id: z.string(),
      variant: z.string(),
      warehouse: z.string(),
      quantity: z.number(),
      team: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
    isNew: z.boolean(),
  }),
});
